<template>
  <div class="relative autocomplete">
    <input
      v-model="label_name"
      type="text"
      class="w-full px-6 py-2 mt-3 bg-white border-gray-300 rounded-sm shadow-sm placeholder-slate-300 border-1 text-primary focus:ring-main-primary focus:shadow-outline focus:border-main-primary"
      required
      :maxlength="maxCharacters"
      @input="onChange"
      @focusin="onFocusIn"
      @keydown.down="onArrowDown"
      @keydown.up="onArrowUp"
      @keydown.enter="onEnter"
      @keyup="removeResults"
    >
    <ul
      v-show="isOpen"
      id="autocomplete-results"
      class="w-full py-2 -mt-2 bg-gray-100 border autocomplete-results border-slate-300"
    >
      <li
        v-if="isLoading"
        class="loading"
      >
        Loading results...
      </li>
      <template v-else>
        <li
          v-for="(result, index) in inputItems"
          :key="result"
          class="autocomplete-result"
          :class="{ 'is-active': index === arrowCounter }"
        >
          <span class="font-medium">{{ result }}</span> - label already exists
        </li>
      </template>
    </ul>
    <small
      class="absolute px-2 py-1 mb-2.5 mt-0.5 text-gray-800 bg-gray-100 border border-gray-300 rounded right-1 top-4"
    >
      {{ remainingChars }}/30
    </small>
  </div>
</template>

<script>
export default {
  name: 'LabelsAutoComplete',

  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    isAsync: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  emits: ['input'],

  data() {
    return {
      isOpen: false,
      results: [],
      inputItems: this.items,
      label_name: '',
      isLoading: false,
      arrowCounter: -1,
      maxCharacters: 30,
      remainingChars: 30,
    }
  },

  watch: {
    items(newItems) {
      this.inputItems = newItems
      this.isOpen = !!newItems.length
    },
    inputItems(value, oldValue) {
      if (value.length !== oldValue.length) {
        this.results = value
        this.isLoading = false
      }
    },
  },

  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },

  unmounted() {
    document.removeEventListener('click', this.handleClickOutside)
  },

  methods: {
    setResult(result) {
      this.label_name = result
      this.isOpen = false
    },
    onChange() {
      this.label_name = this.label_name.replace(/,/g, '')
      this.$emit('input', this.label_name)
      this.remainingChars = this.maxCharacters - this.label_name.length
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false
        this.arrowCounter = -1
      }
    },
    onArrowDown() {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1
      }
    },
    onEnter() {
      this.label_name = this.results[this.arrowCounter]
      this.isOpen = false
      this.arrowCounter = -1
    },
    onFocusIn() {
      if (this.inputItems.length) {
        this.isOpen = true
      }
    },
    removeResults() {
      if (this.label_name === '') {
        this.isOpen = false
        this.arrowCounter = -1
      }
    },
  },
}
</script>

<style scoped>
.autocomplete {
  position: relative;
}

.autocomplete-results {
  border: 1px solid #eeeeee;
  height: 120px;
  overflow: auto;
  margin-bottom: 10px;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  padding: 4px 20px;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: #4aae9b;
  color: white;
}
</style>
